import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
import { usePromiseDoingCallback, useUnmountRef, } from '../../../../../../../helpers/use/useHook';
import RfpOneDescriptionFileDownload from './RfpOneDescriptionFileDownload';
import RfpOneDescriptionFileImage from './RfpOneDescriptionFileImage';
const RfpOneDescriptionLeftColumn = (props) => {
    const { driverTargetOneRef, isActiveDriverTarget, onClickDownload: rawOnClickDownload, onClickDriverTarget, onClickThumbnail, viewRequest, } = props;
    const { offer: { file_images: fileImages }, } = viewRequest;
    const unmountRef = useUnmountRef();
    const [onClickDownload, loading] = usePromiseDoingCallback(rawOnClickDownload, unmountRef);
    return (_jsxs("div", Object.assign({ className: 'left_column' }, { children: [_jsx(RfpOneDescriptionFileImage, { driverTargetRef: driverTargetOneRef, isActiveDriverTarget: isActiveDriverTarget, onClick: onClickThumbnail, onClickDriverTarget: onClickDriverTarget, thumbnail: fileImages[0] || '' }), _jsx(RfpOneDescriptionFileDownload, { loading: loading, onClick: onClickDownload })] })));
};
RfpOneDescriptionLeftColumn.propTypes = {
    driverTargetOneRef: propShape(),
    isActiveDriverTarget: propBool(),
    onClickDownload: propFunc().isRequired,
    onClickDriverTarget: propFunc(),
    onClickThumbnail: propFunc().isRequired,
    viewRequest: propShape().isRequired,
};
RfpOneDescriptionLeftColumn.defaultProps = {
    driverTargetOneRef: null,
    isActiveDriverTarget: false,
    onClickDriverTarget: undefined,
};
export default RfpOneDescriptionLeftColumn;
